module.exports = __webpack_public_path__ + "img/SC-4-delat.bb35399c.jpg";